"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AddressInputFields_1 = require("./AddressInputFields");
var AddressManualInput = function (_a) {
    var name = _a.name, errors = _a.errors, address = _a.address, handleChange = _a.handleChange, validateField = _a.validateField, handleDone = _a.handleDone, clearAddress = _a.clearAddress;
    // Race condition from updating errors from blur and done button
    var deferredDone = function () { return setTimeout(handleDone, 50); };
    return (React.createElement(AddressInputFields_1.default, { name: name, address: address, handleChange: handleChange, errors: errors, clearAddress: clearAddress, handleDone: deferredDone, validateField: validateField }));
};
exports.default = AddressManualInput;
